import React, { useContext } from "react";
import { MapRef } from "react-map-gl";

export type DefaultContext = {
  mapRef: React.MutableRefObject<MapRef | undefined>;
  mapPadding: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
};

const MapContext = React.createContext<DefaultContext>({} as DefaultContext);
const useMap = () => useContext(MapContext);

const MapProvider = ({
  children,
  mapRef,
  mapPadding,
}: {
  children: React.ReactNode;
  mapRef: React.MutableRefObject<MapRef | undefined>;
  mapPadding: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}) => (
  <MapContext.Provider value={{ mapRef, mapPadding }}>
    {children}
  </MapContext.Provider>
);

export { useMap, MapProvider };
